// extracted by mini-css-extract-plugin
module.exports = {"slider-enter-active":"slider-enter-active","slider-leave-active":"slider-leave-active","slider-enter":"slider-enter","slider-leave-to":"slider-leave-to"};